import { LOGIN_FAILED,
  LOGIN_REQUEST,
  LOGIN_SUCCESS,
  LOGIN_CHECK_SUCCESS,
  LOGIN_CHECK_FAILED } from '../../actions/loginActions'

import { LOGOUT_FAILED,
  LOGOUT_REQUEST,
  LOGOUT_SUCCESS,
  IMPERSONATE_END } from '../../actions/logout'
import { REGISTER_SUCCESS } from '../../actions/register';

import { IMPERSONATE_REQUEST, IMPERSONATE_SUCCESS, IMPERSONATE_FAILED, IMPERSONATE_END_CLEAR } from '../../actions/impersonate';

import { FINISH_TUTORIAL_SUCCESS } from "../../actions/finish-tutorial"

import { UPDATE_USER_SUCCESS, UPDATE_USER_FAILED, UPDATE_USER_PICTURE_SUCCESS } from "../../actions/profile/update-profile"

import { RESET_PASSWORD_SUCCESS, RESET_PASSWORD_FAILED } from "../../actions/profile/reset-password"

import { REQUEST_RESET_PASSWORD_FAILED, REQUEST_RESET_PASSWORD_SUCCESS, REQUEST_RESET_PASSWORD_REQUEST } from "../../actions/profile/request-reset-password"

import { RESET_PASSWORD_TOKEN_FAILED, RESET_PASSWORD_TOKEN_SUCCESS } from "../../actions/profile/reset-password-token"

import { GET_MY_SUBSCRIPTIONS_SUCCESS, GET_MY_SUBSCRIPTIONS_FAILED } from "../../actions/subscription/get-my-subscriptions"

const initialState = {
  user: null,
  loggingIn: false,
  loggingOut: false,
  role: null,
  error: null,
  impersonating: false,
  impersonateLoading: false,
  impersonateEnded: false,
  updateError: {
    fieldGroup: null,
    messages: null
  },
  resetPasswordError: null,
  requestResetPasswordError: null,
  requestResetPasswordInProgress: null,
  resetPasswordTokenError: null,
  subscriptions: null
}

export const auth = (state = initialState, action) => {
  switch (action.type) {
    case LOGIN_REQUEST:
      return Object.assign({}, state, {
        loggingIn: true,
        error: null
      })
    case LOGIN_FAILED:
      return Object.assign({}, state, {
        loggingIn: false,
        error: action.error
      })
    case LOGIN_SUCCESS:
      return Object.assign({}, state, {
        loggingIn: false,
        user: action.payload.data.payload,
        role: action.payload.data.payload.role
      })
    case LOGIN_CHECK_SUCCESS: {
      const updatedUser = action.payload.data.payload
      let impersonating = false
      if (updatedUser.impersonated) {
        delete updatedUser.impersonated
        impersonating = true
      }
      return Object.assign({}, state, {
        user: updatedUser,
        impersonating,
        role: action.payload.data.payload.role
      })
    }
    case LOGIN_CHECK_FAILED:
      return Object.assign({}, state, {
        user: null,
        role: null
      })
    case REGISTER_SUCCESS:
      return Object.assign({}, state, {
        registering: false,
        user: action.payload.data.payload
      })
    case LOGOUT_REQUEST:
      return Object.assign({}, state, {
        loggingOut: true,
        error: null
      })
    case LOGOUT_FAILED:
      return Object.assign({}, state, {
        loggingOut: false,
        error: action.error
      })
    case LOGOUT_SUCCESS:
      return Object.assign({}, state, {
        loggingOut: false,
        user: null,
        role: null
      })

    case IMPERSONATE_REQUEST:
      return Object.assign({}, state, {
        impersonateLoading: true,
        error: null
      })
    case IMPERSONATE_FAILED:
      return Object.assign({}, state, {
        impersonateLoading: false,
        error: action.error,
        impersonateEnded: false,
      })
    case IMPERSONATE_SUCCESS:
      return Object.assign({}, state, {
        impersonateLoading: false,
        user: action.payload.data.payload,
        role: 2,
        impersonateEnded: false,
        impersonating: true
      })
    case IMPERSONATE_END:
      return Object.assign({}, state, {
        user: action.payload.data.payload,
        role: 3,
        impersonating: false,
        impersonateEnded: true,
      })
    case IMPERSONATE_END_CLEAR:
      return Object.assign({}, state, {
        impersonateEnded: false
      })
    case FINISH_TUTORIAL_SUCCESS:
      return Object.assign({}, state, {
        user: {
          ...state.user, watchedTutorial: true
        },
      })
    case UPDATE_USER_SUCCESS:
      return Object.assign({}, state, {
        user: action.payload.data.payload,
        updateError: {
          messages: null,
          fieldGroup: null
        }
      })
    case UPDATE_USER_PICTURE_SUCCESS:
      return Object.assign({}, state, {
        user: action.payload.data.payload
      })
    case UPDATE_USER_FAILED:
      return Object.assign({}, state, {
        updateError: {
          fieldGroup: action.fieldGroup,
          messages: action.error
        }
      })

    case RESET_PASSWORD_SUCCESS:
      return Object.assign({}, state, {
        user: action.payload.data.payload,
        resetPasswordError: null
      })
    case RESET_PASSWORD_FAILED:
      return Object.assign({}, state, {
        resetPasswordError: action.error
      })

    case REQUEST_RESET_PASSWORD_REQUEST:
      return {
        ...state, requestResetPasswordError: null, requestResetPasswordInProgress: true
      }
    case REQUEST_RESET_PASSWORD_SUCCESS:
      return Object.assign({}, state, {
        requestResetPasswordError: null,
        requestResetPasswordInProgress: false
      })
    case REQUEST_RESET_PASSWORD_FAILED:
      return Object.assign({}, state, {
        requestResetPasswordError: action.error,
        requestResetPasswordInProgress: false
      })

    case RESET_PASSWORD_TOKEN_SUCCESS:
      return Object.assign({}, state, {
        resetPasswordTokenError: null
      })
    case RESET_PASSWORD_TOKEN_FAILED:
      return Object.assign({}, state, {
        resetPasswordTokenError: action.error
      })
    case GET_MY_SUBSCRIPTIONS_SUCCESS:
      return Object.assign({}, state, {
        subscriptions: action.payload.data.payload
      })
    case GET_MY_SUBSCRIPTIONS_FAILED:
      return Object.assign({}, state, {
        subscriptions: []
      })

    default:
      return state
  }

}



// WEBPACK FOOTER //
// ./src/redux/reducers/user/auth.js